export default __webpack_public_path__ + "static/media/logo.91a0c3de.svg";